/** נתיב ציבורי יציב (לא webpack media) — מאפשר preload ו־Cache-Control ארוך בלי לשנות hash */
export const DILEMA_LOGO_URL = `${process.env.PUBLIC_URL || ""}/img/dilema.png`;
